export default {
  drawer: "drawer",
  inline: "inline",
};
